export default {
  name: 'languages-switcher',
  events: [
    {
      on: 'change',
      handle: (e) => {
        window.location.href = e.currentTarget.value
      },
    },
  ],
}
